import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SafetyHardhat = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 12H26V11C26 6.037 21.514 2 16 2C10.486 2 6 6.037 6 11V12H5C3.346 12 2 13.346 2 15C2 16.654 3.346 18 5 18H6.116C6.287 19.161 6.693 21.262 7.577 23.385C9.38 27.713 12.293 30 16 30C19.707 30 22.62 27.712 24.423 23.385C25.308 21.262 25.713 19.161 25.884 18H27C28.654 18 30 16.654 30 15C30 13.346 28.654 12 27 12ZM22.56 22.655C21.071 26.202 18.864 28 16 28C13.136 28 10.928 26.201 9.44 22.655C8.699 20.891 8.322 19.101 8.142 18H23.859C23.679 19.101 23.301 20.891 22.561 22.655H22.56ZM27 16H5C4.449 16 4 15.551 4 15C4 14.449 4.449 14 5 14H9C9.552 14 10 13.552 10 13C10 12.448 9.552 12 9 12H8V11C8 8.415 9.611 6.154 12 4.942V9C12 9.552 12.448 10 13 10C13.552 10 14 9.552 14 9V4.221C14.639 4.077 15.31 4 16 4C16.69 4 17.361 4.077 18 4.221V9C18 9.552 18.448 10 19 10C19.552 10 20 9.552 20 9V4.942C22.389 6.154 24 8.415 24 11V12H23C22.448 12 22 12.448 22 13C22 13.552 22.448 14 23 14H27C27.551 14 28 14.449 28 15C28 15.551 27.551 16 27 16Z" />
	</svg>
);

export default SafetyHardhat;
